<script setup lang="ts">
import { config } from "@/lib/variantConfig";
</script>

<template>
  <div class="bg-background-brand text-text-white rounded-lg p-4">
    <h4 class="font-black mb-1">
      {{ $t("subscription_cta.title", [config.strings.app_name]) }}
    </h4>
    <p class="opacity-80 mb-6">
      {{ $t("subscription_cta.description") }}
    </p>
    <a class="btn-white" :href="config.links.subscription_url">
      {{ $t("subscription_cta.button") }}
    </a>
  </div>
</template>
